<div *ngIf="loading$ | async" class="overlay">
    <mat-spinner></mat-spinner>

</div>
<!-- 
<div class="spinner-container" *ngIf="loading$ | async">
    <mat-spinner color="accent" diameter="50"></mat-spinner>
    <img src="assets/vpartner_logo.png" alt="Loading..." class="custom-image" />
</div> -->